import { BaseMapper } from '../../../../shared/mappers/base.mapper';
import { Product } from '../models/product.type';

export class ProductMapper extends BaseMapper<Product> {
   
}
